export enum NotificationType {
  success = 'success',
  error = 'error',
  //TODO add Not Found logic
  notFound = 'Not Found',
  info = 'info',
}
